import React, { useState } from "react";
import { motion } from "framer-motion";
import { Award, Eye } from "lucide-react";
import { CERTIFICATES } from "../data/portfolioData";
import CertificateModal from "./CertificateModal";

export default function Certificates() {
  const [selectedCert, setSelectedCert] = useState(null);

  const marqueeList = [...CERTIFICATES, ...CERTIFICATES, ...CERTIFICATES];

  return (
    <section id="certificates" className="py-20 relative overflow-hidden bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-xs font-mono font-semibold"
          >
            <Award size={14} /> CERTIFICATIONS & CREDENTIALS
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900"
          >
            Verified Industry <span className="gradient-text-indigo">Certifications</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-slate-600 text-base leading-relaxed"
          >
            Infinite scrolling credential Showcase. Hover to pause marquee. Click any certificate to open full verification view.
          </motion.p>
        </div>
      </div>

      {/* Infinite Auto-scrolling Carousel Container */}
      <div className="mt-14 w-full overflow-hidden py-4 border-y border-slate-200 bg-white/70 backdrop-blur-md">
        <div className="animate-marquee flex gap-6 px-4">
          {marqueeList.map((c, i) => (
            <div
              key={c.name + i}
              onClick={() => setSelectedCert(c)}
              className="group relative shrink-0 w-72 h-48 rounded-2xl p-1 bg-white border border-slate-200 hover:border-indigo-400 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md overflow-hidden flex flex-col justify-between"
            >
              {/* Image Banner */}
              <div className="relative w-full h-32 rounded-xl overflow-hidden bg-slate-100">
                <img
                  src={c.src}
                  alt={c.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-slate-900/30 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-indigo-600 text-white font-semibold text-xs shadow-md">
                    <Eye size={14} /> View Certificate
                  </span>
                </div>
              </div>

              {/* Card Label */}
              <div className="px-2 pb-1 flex items-center justify-between">
                <div className="truncate">
                  <h4 className="text-xs font-bold text-slate-900 truncate group-hover:text-indigo-600 transition-colors">
                    {c.name}
                  </h4>
                  <span className="text-[10px] text-slate-500 font-mono">{c.category}</span>
                </div>
                <Award size={16} className="text-amber-500 shrink-0 ml-2" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Certificate Modal */}
      {selectedCert && (
        <CertificateModal certificate={selectedCert} onClose={() => setSelectedCert(null)} />
      )}
    </section>
  );
}
